import { cn } from "@/utils/cn";
import logoSrc from "@/assets/logo.png";

interface LogoProps {
  className?: string;
  variant?: "full" | "mark";
  size?: number;
}

/**
 * Identidade visual do Palpiteiro Certo — logo oficial fornecido pelo
 * usuário (ícone de app com o "P" em 3D + bola, fundo azul/dourado). Usado
 * tanto como marca d'água pequena no cabeçalho (variant="full", ao lado do
 * nome em texto) quanto sozinho, maior, em telas de carregamento/erro/
 * autenticação (variant="mark").
 */
export function Logo({ className, variant = "full", size = 36 }: LogoProps) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <img src={logoSrc} alt="Palpiteiro Certo" width={size} height={size} className="rounded-xl" style={{ width: size, height: size }} />
      {variant === "full" && (
        <span className="font-display text-lg font-extrabold tracking-tight text-foreground">
          Palp<span className="text-primary">iteiro</span> Certo
        </span>
      )}
    </div>
  );
}
